import { isDocumentVisible } from 'owa-analytics/lib/utils/visibilityState';
import { getLastFrameEndTime } from './models/frameEndTimes';

export default function onTabVisibilityChanged() {
    const previousFrame = getLastFrameEndTime();
    if (previousFrame) {
        previousFrame.isNextFrameBackground =
            previousFrame.isNextFrameBackground || !isDocumentVisible();
    }
}
